import React from 'react';
import CouponForm from './form';
import {normalizer} from './pipeline';
import {addStoreItem} from '../../modules/Api';
import {notification} from 'antd';
import history from "../../modules/History";

class AddStore extends React.Component {
    constructor() {
        super();
        this.state = {
            submitted: false
        }
    }
    submit(values) {
        if(this.state.submitted){
            return;
        }
        this.setState({submitted: true});
        const formData = normalizer(values);
        addStoreItem(formData, () => {
            notification.open({
                message: `فروشگاه با موفقیت اضافه شد!`,
                description: `فروشگاه ثبت شد. می توانید آن را در لیست فروشگاه ها مشاهده کنید و در صورت نیاز ویرایش کنید.`
            });
            this.setState({submitted: false});
            history.item.push(`/stores`);
        });
    }
    render() {
        return (<div><CouponForm submit={this.submit.bind(this)} submitted={this.state.submitted}/></div>);
    }
}

export default AddStore;


// WEBPACK FOOTER //
// ./src/containers/Stores/add.js